import { z } from 'zod';
import { BookSchema, BookTypeEnumSchema, GlobalBookCornSchema } from '../base/books.js';
import { ContactCornSchema } from '../base/contacts.js';
import { BookContactQueryModelSchema } from './contact.js';
export const LegacyBookQueryModelSchema = BookSchema.extend({
    PK: z.string(), //'BOOK#<<bookId>>'
    SK: z.string(), //'<<bookId>>'
    'GSI-PK-1': BookTypeEnumSchema,
    'GSI-SK-1': z.string(), //'<<bookId>>'
    contacts: z.record(ContactCornSchema, BookContactQueryModelSchema),
});
export const NonGlobalBookQueryModelV3Schema = BookSchema.extend({
    PK: z.string(), //'BOOK#<<bookId>>'
    SK: z.string(), //'<<bookId>>'
    'GSI-PK-1': BookTypeEnumSchema,
    'GSI-SK-1': z.string(), //'<<bookId>>'
    contactIds: z.set(ContactCornSchema),
    schemaVersion: z.literal(3),
});
export const GlobalBookQueryModelV3Schema = BookSchema.extend({
    bookId: GlobalBookCornSchema,
    PK: z.string(), //'BOOK#<<bookId>>'
    SK: z.string(), //'<<bookId>>'
    'GSI-PK-1': z.literal(BookTypeEnumSchema.enum['global']),
    'GSI-SK-1': z.string(), //'<<bookId>>'
    contactMap: z.record(ContactCornSchema, BookContactQueryModelSchema),
    schemaVersion: z.literal(3),
});
